export class CciNistMappingItem {
  cci: string;
  nistId: string;

  constructor(cci: string, nistId: string) {
    this.cci = cci;
    this.nistId = nistId;
  }
}
